<div class="wrapper cv-dialog-form organization-container">
	<div class="row">
		<div class="col-sm-12">
			<cv-multiselect-search
				[required]="true"
				[label]="'Acuity Branch'"
				[placeholder]="'Select a branch'"
				[options]="acuityLenderBranchesList"
				[optionText]="'title'"
				[optionValue]="'id'"
				[singleSelectMode]="true"
				[values]="acuityAppScopeBranchSelected"
				(valuesChange)="onAcuityAppScopeBranchSelected($event)"
				[getOptionsFunction]="lenderService.getAcuityLenderBranches"
			>
			</cv-multiselect-search>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-multiselect-search
				[label]="'AppScope Client'"
				[placeholder]="'Select a branch'"
				[options]="lendersList"
				[values]="lenderSelected"
				[optionText]="'title'"
				[optionValue]="'id'"
				[singleSelectMode]="true"
				[getOptionsFunction]="lenderService.getLenders"
				(valuesChange)="onLenderSelected($event)"
			>
			</cv-multiselect-search>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-multiselect-search
				[required]="true"
				[label]="'Cmp Acuity Branch'"
				[placeholder]="'Select a branch'"
				[options]="cmpAcuityLenderBranchesList"
				[optionText]="'title'"
				[optionValue]="'id'"
				[singleSelectMode]="true"
				[values]="cmpAcuityAppScopeBranchSelected"
				(valuesChange)="onCmpAcuityBranchSelected($event)"
				[getOptionsFunction]="lenderService.getCmpAcuityLenderBranches"
			>
			</cv-multiselect-search>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="lenderMapperData.insideMapsOrgId = $event.value.trim()"
				[value]="lenderMapperData.insideMapsOrgId"
				[label]="'InsideMaps Organization Id'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[placeholder]="'InsideMaps Organization Id'"
			></cv-input>
		</div>
	</div>
</div>
